export default "__VITE_ASSET__Bpu50SqP__"